<script lang="ts">
  // 8 · Done: what was set up, and where to go next.
  import { Check, Sparkles, CalendarDays, CalendarRange, Repeat, Users, BellRing, Timer, LayoutDashboard } from '@lucide/svelte';
  import { t } from '../../i18n.svelte';
  import { Button } from '../../ui';
  import StepIntro from './StepIntro.svelte';
  import { flow } from '../state.svelte';

  const ICONS = { rate: Sparkles, week: CalendarDays, period: CalendarRange, round: Repeat, client: Users, notif: BellRing };
  const summary = $derived(
    (['rate', 'week', 'period', 'round', 'client', 'notif'] as const)
      .filter((key) => flow.saved[key])
      .map((key) => ({ icon: ICONS[key], text: flow.saved[key] as string }))
  );
</script>

<StepIntro kicker={t('onb.done.kicker')} title={t('onb.done.title')} lead={t('onb.done.text')} focus={false} />

{#if summary.length}
  <ul class="summary">
    {#each summary as item, i (i)}
      <li style:animation-delay="{flow.still ? 0 : 120 + i * 70}ms">
        <span class="icon"><item.icon size={14} /></span>
        <span class="text">{item.text}</span>
        <span class="check"><Check size={15} /></span>
      </li>
    {/each}
  </ul>
{/if}

<div class="finish">
  <Button variant="primary" size="lg" block data-step-focus onclick={() => flow.finish('done', '/app/timer')}>
    {#snippet icon()}<Timer />{/snippet}
    {t('onb.done.timer')}
  </Button>
  <Button size="lg" block onclick={() => flow.finish('done', '/app')}>
    {#snippet icon()}<LayoutDashboard />{/snippet}
    {t('onb.done.dashboard')}
  </Button>
</div>
<p class="tip">{t('onb.done.tip')}</p>

<style>
  .summary { list-style: none; margin: 0 0 var(--space-4); padding: 0; display: flex; flex-direction: column; gap: var(--space-2); }
  .summary li {
    display: flex;
    align-items: center;
    gap: var(--space-2_5);
    padding: var(--space-2_5) var(--space-3);
    border: 1px solid var(--border);
    border-radius: var(--radius-sm);
    background: var(--surface-2);
    font-size: var(--text-sm);
    font-weight: var(--weight-medium);
    animation: rise-in 320ms var(--ease) both;
  }
  .icon { display: grid; place-items: center; flex-shrink: 0; width: var(--space-6); height: var(--space-6); border-radius: var(--radius-xs); background: var(--brand-soft); color: var(--brand); }
  .text { flex: 1; min-width: 0; }
  .check { display: inline-flex; color: var(--success); }
  .finish { display: flex; flex-direction: column; gap: var(--space-2_5); max-width: 380px; }
  .tip { margin-top: var(--space-4); font-size: var(--text-sm); color: var(--text-3); }

  @media (max-width: 720px) {
    .finish { max-width: none; }
  }
</style>
